import styled from 'styled-components'

export const ContainerCarouselBanner = styled.div`
  width: 100%;
  padding: 0 0 0 24px;
`
